import { render } from "./SettingInfo.vue?vue&type=template&id=14cfb5e7&ts=true&lang=pug"
import script from "./SettingInfo.vue?vue&type=script&lang=ts"
export * from "./SettingInfo.vue?vue&type=script&lang=ts"

import "./SettingInfo.vue?vue&type=style&index=0&id=14cfb5e7&lang=scss"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Sultan/CMS Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__